import { ViewModel, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { DistrictSelector } from "../../districts/districtManipulation/districtSelector";
import { ICashBox } from "../ICashBox";
import { CashBoxEditorView } from "./cashBoxEditor-view"

export class CashBoxEditorViewModel extends ViewModel implements ICashBox, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);

        this.districtSelector = new DistrictSelector(this);
        this.districtSelector.onSelectionChanged = x => {
            this.districtId = x.id
        };
        this.disabled = false;
        this._updater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new CashBoxEditorView();
    }
    public getTypeId(): string {
        return "VM-299837A5-9BED-4563-9C50-CB98CCEEC652"
    }
    closePopup(result: any) {
    }


    cloneTo(cashbox: ICashBox) {
        cashbox.id = this.id;
        cashbox.districtId = this.districtId;
        cashbox.disabled = this.disabled;
    }

    private _updater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector; } private _districtSelector: DistrictSelector;
    public set disabled(v: boolean) { this._disabled = v; } public get disabled(): boolean { return this._disabled; } private _disabled: boolean;
    public set districtId(v: string) {
        this._districtId = v;
        this.districtSelector.selectById(v);
    } public get districtId(): string { return this._districtId; } private _districtId: string;

    back() {
        this.closePopup(null);
    }
    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), translate("cashBoxEditor-viewModel.chashBoxError", {}));
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess(translate("cashBoxEditor-viewModel.cashBoxRegistered", {}), translate("cashBoxEditor-viewModel.successfulRegistration", {}));
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning(translate("cashBoxEditor-viewModel.chashBoxError", {}), translate("cashBoxEditor-viewModel.error", {}));
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push(translate("cashBoxEditor-viewModel.cashBoxNameError", {}));
        }
        if (stringIsNullOrEmpty(this.districtId)) {
            result.push(translate("cashBoxEditor-viewModel.branchError", {}))
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(cashbox: ICashBox): Promise<any>;
}

export class CashDeskInserter implements IServerUpdater {
    async execute(cashbox: ICashBox): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/CashDeskManipulationServices/CreateNewCashDesk', {
                Name: cashbox.name,
                DistrictId: cashbox.districtId,
                Disabled: cashbox.disabled
            });
            if (result.IsSuccessful == false) {
                throw "Error Saving District";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

export class CashDeskUpdater implements IServerUpdater {
    async execute(cashbox: ICashBox): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/CashDeskManipulationServices/UpdateCashDesk', {
                CashDeskId: cashbox.id,
                Name: cashbox.name,
                DistrictId: cashbox.districtId,
                Disabled: cashbox.disabled
            });
            if (result.IsSuccessful == false) {
                throw "Error Saving Cash Desk";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}